import React, { Component } from "react"
import ReactEcharts from "echarts-for-react"
import { Row, Col } from "reactstrap"

class Co2Emmission extends Component<any> {
    vesselStay = () => {
        let co2EmmissionArray: any[] = [
            {
                type: 'At Sea',
                co2_emission_fo: 0,
                co2_emission_do: 0,
                total: 0
            },
            {
                type: 'In Port',
                co2_emission_fo: 0,
                co2_emission_do: 0,
                total: 0
            }
        ];

        this.props.pieChartData.filter((item: any) => item.vessel === this.props.VesselID.vesselId).map((data: any) => {
            if (data.vessel_position_id === 1) {
                co2EmmissionArray[1].co2_emission_fo = co2EmmissionArray[1].co2_emission_fo + data.co2_emission_fo;
                co2EmmissionArray[1].co2_emission_do = co2EmmissionArray[1].co2_emission_do + data.co2_emission_do;
                co2EmmissionArray[1].total = co2EmmissionArray[1].co2_emission_fo + co2EmmissionArray[1].co2_emission_do;
            } else {
                co2EmmissionArray[0].co2_emission_fo = co2EmmissionArray[0].co2_emission_fo + data.co2_emission_fo;
                co2EmmissionArray[0].co2_emission_do = co2EmmissionArray[0].co2_emission_do + data.co2_emission_do;
                co2EmmissionArray[0].total = co2EmmissionArray[0].co2_emission_fo + co2EmmissionArray[0].co2_emission_do;
            }
            return '';
        })
        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "item",
                formatter: (params: any) => `${params.seriesName} <br/>${params.data.name} : ${params.percent}% (${(params.data.value).toFixed(2)} mt)`,
            },
            legend: {
                orient: "vertical",
                left: "left",
                data: co2EmmissionArray.map((data: any) => { return data.type.toString() }),
                // textStyle: {
                //   color: ["#858d98"],
                // },
            },
            color: ['#ab4948', '#707070'],
            series: [
                {
                    name: "Co2 Emmission",
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "60%"],
                    data: co2EmmissionArray.map((data: any) => {
                        return {
                            value: data.total,
                            name: data.type
                        }
                    }),
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                },
            ],
        }
    }
    inPortOp = () => {
        let co2EmmissionArray: any = {
            type: 'In Port',
            operations: [
                { id: 2, emmission: 0, name: 'Port Stay' },
                { id: 3, emmission: 0, name: 'Anchor Stay' },
                { id: 5, emmission: 0, name: 'Drifting' },
            ],
            total: 0
        };

        this.props.pieChartData.filter((item: any) => item.vessel === this.props.VesselID.vesselId).map((data: any) => {
            return co2EmmissionArray.operations.filter((item: any) => item.id === data.reporting_operation_id).map((op: any) => {
                return op.emmission = op.emmission + data.co2_emission_fo + data.co2_emission_do;
            })
        })
        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "item",
                formatter: (params: any) => `${params.seriesName} <br/>${params.data.name} : ${params.percent}% (${(params.data.value).toFixed(2)} mt)`,
            },
            legend: {
                orient: "vertical",
                left: "left",
                data: co2EmmissionArray.operations.map((data: any) => {
                    return data.name.toString();
                }),
                // textStyle: {
                //   color: ["#858d98"],
                // },
            },
            color: ['#c77c7d', '#dcb1b0', '#eacaca', '#b84e4d'],
            series: [
                {
                    name: "Co2 Emmission- In Port operations",
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "60%"],
                    data: co2EmmissionArray.operations.map((data: any) => {
                        return {
                            value: data.emmission,
                            name: data.name
                        }
                    }),
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                },
            ],
        }
    }
    atSeaOp = () => {
        let co2EmmissionArray: any = {
            type: 'At Sea',
            operations: [
                { id: 1, emmission: 0, name: 'Sea Passage' },
                { id: 4, emmission: 0, name: 'Maneuvering' },
                { id: 6, emmission: 0, name: 'Drifting' },
            ],
            total: 0
        };

        this.props.pieChartData.filter((item: any) => item.vessel === this.props.VesselID.vesselId).map((data: any) => {
            return co2EmmissionArray.operations.filter((item: any) => item.id === data.reporting_operation_id).map((op: any) => {
                return op.emmission = op.emmission + data.co2_emission_fo + data.co2_emission_do;
            })
        })
        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "item",
                formatter: (params: any) => `${params.seriesName} <br/>${params.data.name} : ${params.percent}% (${(params.data.value).toFixed(2)} mt)`,
            },
            legend: {
                orient: "vertical",
                left: "left",
                data: co2EmmissionArray.operations.map((data: any) => {
                    return data.name.toString();
                }),
                // textStyle: {
                //   color: ["#858d98"],
                // },
            },
            color: ['#999999', '#DADCE0', '#718190'],
            series: [
                {
                    name: "Co2 Emmission- At Sea operations",
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "60%"],
                    data: co2EmmissionArray.operations.map((data: any) => {
                        return {
                            value: data.emmission,
                            name: data.name
                        }
                    }),
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                },
            ],
        }
    }
    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col lg={4}>
                        <h6>CO<sub>2</sub> Emmission</h6>
                        <ReactEcharts style={{ height: "350px" }} option={this.vesselStay()} />
                    </Col>
                    <Col lg={4}>
                        <h6>In Port operations</h6>
                        <ReactEcharts style={{ height: "350px" }} option={this.inPortOp()} />
                    </Col>
                    <Col lg={4}>
                        <h6>At Sea operations</h6>
                        <ReactEcharts style={{ height: "350px" }} option={this.atSeaOp()} />
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}
export default Co2Emmission;
